<div class="table-wrapper" *ngIf="totalCount > 0">
  <!-- <ngx-loading  [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading> -->

  <div class="custom-card">
    <table mat-table [dataSource]="dataSource">
      <!-- S. No Column -->
      <ng-container matColumnDef="S. No">
        <th mat-header-cell *matHeaderCellDef>S. No</th>
        <td mat-cell *matCellDef="let element; let i = index"> {{i + 1 + offset}}</td>
      </ng-container>

      <!-- Upload id Column -->
      <ng-container matColumnDef="Upload id">
        <th mat-header-cell *matHeaderCellDef>Calculate id</th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.name}} </td>
      </ng-container>

      <!-- city_name Column -->
      <!-- <ng-container matColumnDef="city_name">
        <th mat-header-cell *matHeaderCellDef>City Name</th>
        <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.city_name}} </td>
      </ng-container> -->
      <!-- city_id Column
      <ng-container matColumnDef="city_id">
        <th mat-header-cell *matHeaderCellDef >City Id</th>
        <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.city_id}} </td>
      </ng-container> -->

      <!-- record_processed Column -->
      <ng-container matColumnDef="sync_record_processed" *ngIf="selectedLayerType == 'direction'">
        <th mat-header-cell *matHeaderCellDef>Sync Record Processed</th>
        <td mat-cell *matCellDef="let element" style="text-align: left;">
          <app-progress-bar [isProgress]="'isProgress'" [percent]="element?.table_progress"
            [min]="element?.record_processed || element?.record_processed"
            [max]="element?.record_to_be_processed || (element?.total_sync_records)">
          </app-progress-bar>
        </td>
      </ng-container>

      <!-- Added date Column -->
      <ng-container matColumnDef="added_date">
        <th mat-header-cell *matHeaderCellDef style="min-width: 170px;">Added date</th>
        <td mat-cell *matCellDef="let element"> {{getFormatedDate(element.added_date) ?
          getFormatedDate(element.added_date): '--'}}</td>
      </ng-container>
      <!-- Updated date Column -->
      <ng-container matColumnDef="start_date">
        <th mat-header-cell *matHeaderCellDef style="min-width: 170px;">Start Date</th>
        <td mat-cell *matCellDef="let element"> <span
            *ngIf="element.execution_start_date">{{getFormatedDate(element.execution_start_date)}}</span> <span
            *ngIf="!element.execution_start_date">--</span></td>
      </ng-container>
        <ng-container matColumnDef="end_date">
        <th mat-header-cell *matHeaderCellDef style="min-width: 170px;">End Date</th>
        <td mat-cell *matCellDef="let element"> <span
            *ngIf="element.execution_end_date"> {{getFormatedDate(element.execution_end_date)}}</span>
            <span *ngIf="!element.execution_end_date">--</span>
          </td>
      </ng-container>
      <!-- Count Column -->
      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef> Count </th>
        <td mat-cell *matCellDef="let element"> {{element.existing_count ? element.existing_count : '--'}} </td>
      </ng-container>
      <!-- New count Column -->
      <ng-container matColumnDef="new_count">
        <th mat-header-cell *matHeaderCellDef> New count </th>
        <td mat-cell *matCellDef="let element"> {{element.new_count ? element.new_count : '--'}} </td>
      </ng-container>
      <!-- Target Column -->
      <!-- <ng-container matColumnDef="Target_count">
          <th mat-header-cell *matHeaderCellDef> Target count </th>
          <td mat-cell *matCellDef="let element"> 10 </td>
        </ng-container> -->
      <!-- Log Column -->
      <ng-container matColumnDef="Log_files">
        <th mat-header-cell *matHeaderCellDef> Logs </th>
        <td mat-cell *matCellDef="let element"> <button type="button" class="log-btn"
            (click)="downloadLog(element.logfile)">Log</button> </td>
      </ng-container>
      <!-- Error Column -->
      <!-- <ng-container matColumnDef="Error_files">
          <th mat-header-cell *matHeaderCellDef> Error logs </th>
          <td mat-cell *matCellDef="let element"> <button type="button" class="log-btn">Error Logs</button>  </td>
        </ng-container> -->
      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button class="running status-btn" *ngIf="element.status == 1"> Running </button>
          <button class="success status-btn" *ngIf="element.status == 2"> Success </button>
          <button class="success status-btn" *ngIf="element.status == 4"> Synced </button>
          <button class="syncing-btn status-btn" *ngIf="element.status == 3">Syncing </button>
          <button class="failed status-btn" *ngIf="element.status == -1"> Failed </button>
          <button class="failed status-btn" *ngIf="element.status == -2"> Stopped </button>
          <button class="running status-btn" *ngIf="element.status == 0"> Started </button>
            <!-- New Status: Paused -->
    <button class="paused status-btn" *ngIf="element.status == 5"> Paused </button>

    <!-- New Status: Cancelled -->
    <button class="cancelled status-btn" *ngIf="element.status == 6"> Cancelled </button>
                    <!-- <button class="running status-btn" *ngIf="element.status == -3"> Started </button> -->
          <button class="unknown-status" *ngIf="element.status == -3"> -- </button>
        </td>
      </ng-container>
      <!-- Action Column -->
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <span class="d-flex justify-content-center align-items-center">
            <!-- || element.status == 0 || element.status == -3 || element.status == 0-->
            <!-- <button class="stop-process action-btn" [title]="element.status == -2 ? 'Stopped':'Stop Process'"
              [disabled]="element.status == -2" *ngIf="element.status == 1 || element.status == -2"
              (click)="openConfirmation(element)">
              <img src="assets/icon/stop-process.svg" alt="">
            </button> -->
            <!-- <button
              class="stop-process action-btn"
              [ngClass]="{ 'ml-2': element.status === 1 }"
              title="Check Status"
              [disabled]="element.status !== 1 && element.status !== -1"
              *ngIf="(element.status == 1 || element.status == -1)"
              (click)="processExecutionTrackerLoader(element)">
              <img src="../../../../../assets/icon/in-progress.svg" alt="">
            </button> -->
            <!-- <button class="stop-process action-btn" [ngClass]="{ 'ml-2': element.status === 1 }"
              [title]="element.status !== 1 && element.status !== -1 ? 'Check Status':'Check Status'"
              [disabled]="element.status !== 1 && element.status !== -1"
              *ngIf="element.status == 1 || element.status == -1 " (click)="processExecutionTrackerLoader(element)">
              <img src="../../../../../assets/icon/in-progress.svg" alt="">
            </button> -->
          </span>
        <span style="display: flex; align-items: center; justify-content: center;">
            <!-- <button type="button" class="sync action-btn" [disabled]="element.status == 4"
            [title]="element.status == 4 ? 'Synced':'Sync Process'" *ngIf="element.status == 2 || element.status == 4"
            (click)="syncProcess(element)">
            <img src="assets/icon/sync-process.svg" alt="">
          </button> -->
              <!-- <button style="background: none;" type="button" class="sync action-btn" [disabled]="element.status == 4"
            [title]="element.status == 2 ? 'Cancel Sync':'Cancel Process'" *ngIf="element.status == 0 || element.status == -3 || element.status == 2"
            (click)="updateStatus(element, 'cancel', element.status)">
            <img style="width: 100%;min-width: 26px; margin-top: -2px;" src="assets/icon/cancel.png" alt="">
          </button> -->

            <!-- <button style="background: none;" type="button" class="sync action-btn" [disabled]="element.status == 4"
            [title]="'Pause Process'" *ngIf="element.status == 0 || element.status == -3"
            (click)="updateStatus(element, 'pause', element.status)">
            <img style="width: 100%;min-width: 26px; margin-top: -2px;" src="assets/icon/pause.png" alt="">
          </button> -->
            <!-- <button style="background: none;" type="button" class="sync action-btn" [disabled]="element.status == 4"
            [title]="'Resume Process'" *ngIf="element.status == 5"
            (click)="updateStatus(element, 'resume', element.status)">
            <img style="width: 100%;min-width: 26px; margin-top: -2px;" src="assets/icon/play-button.png" alt="">
          </button> -->
        </span>
          <!-- && element.status != -3 -->
          <span

            *ngIf="element.status != 2  && element.status != 1 && element.status != -1  && element.status != 0 && element.status != -3 && element.status != 5">
            -- </span>

    <button  *ngIf="!(element.status != 2  &&
           element.status != 1 && element.status != -1 && element.status != 0 &&
           element.status != -3 && element.status != 5)" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
  <div class="menu-actions">

    <button *ngIf="element.status == 0 || element.status == -3"  (click)="updateStatus(element, 'pause', element.status)" class="pause-btn">
      Pause
    </button>

    <button  *ngIf="element.status == 1 || element.status == -2"
              (click)="openConfirmation(element)" class="stop-btn">
      Stop Process
    </button>
     <button   *ngIf="(element.status == 1 || element.status == -1)"
              (click)="processExecutionTrackerLoader(element)" class="stop-btn">
     Track Progress
    </button>

    <button  (click)="syncProcess(element)" *ngIf="element.status == 2" class="sync-btn">
      Sync Process
    </button>

    <button  *ngIf="element.status == 0 || element.status == -3 || element.status == 2" (click)="updateStatus(element, 'cancel', element.status)" class="cancel-btn">
      Cancel
    </button>

    <button *ngIf="element.status == 5" (click)="updateStatus(element, 'resume', element.status)" class="resume-btn">
      Resume
    </button>

  </div>
</mat-menu>

        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>


    <!-- <div class="">
      No Records Available
    </div> -->
  </div>
  <div class="pagination-wrapper">
    <mat-paginator [length]="totalCount"  [pageSize]="limit" [pageIndex]="pageIndex"  showFirstLastButtons [pageSizeOptions]="pageSizeOptions"
      (page)="pageAction($event)">
    </mat-paginator>
  </div>
</div>

<ngx-loading [show]="loader" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading>
